import 'core-js/modules/es.array.map.js';
import 'core-js/modules/es.object.assign.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import React from 'react';
import classNames from 'classnames';

/**
 * MenuSection
 * =============================================================================
 * The `MenuSection` component that renders a list of `Menu.Item`s. All the children
 * should have the same props.
 *
 * -----------------------------------------------------------------------------
 * Examples
 * -----------------------------------------------------------------------------
 *
 * ```
 * <Menu.Section>
 *   <Menu.Item hasCheckbox>Option 1</Menu.Item>
 *   <Menu.Item hasCheckbox>Option 2</Menu.Item>
 *   <Menu.Item hasCheckbox>Option 3</Menu.Item>
 * </Menu.Section>
 * ```
 *
 * -----------------------------------------------------------------------------
 * Properties
 * -----------------------------------------------------------------------------
 */
var MenuSection = function MenuSection(_ref) {
  var label = _ref.label,
    hasCheckbox = _ref.hasCheckbox,
    icon = _ref.icon,
    iconPlacement = _ref.iconPlacement,
    children = _ref.children,
    className = _ref.className;
  return jsxs("div", {
    className: classNames('cogs-v10', 'cogs-menu-section', className),
    children: [jsx("div", {
      className: "cogs-v10 cogs-menu-header",
      children: label
    }), React.Children.map(children, function (child) {
      // this will be a temp fix until we further come to a resolution on what are the exact props that should be allowed.
      var childProps = child.props;
      return /*#__PURE__*/React.cloneElement(child, Object.assign({
        hasCheckbox: hasCheckbox,
        icon: icon,
        iconPlacement: iconPlacement
      }, childProps));
    })]
  });
};

export { MenuSection };
